import { Flex, Icons, Section } from 'components';

import './styles.scss';
import styled from 'styled-components';
import { useEffect, useState } from 'react';

const Icon = styled(Icons)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.primary_400};
`;

interface SubmenuProps {
  areas: string[];
  areaIndex: number;
  onAreaClick: (index: number) => void;
}
interface TabProps {
  areaIndex: boolean;
}
const Wrapper = styled.div`
  background: ${({ theme }) => theme.colors.white};

  border-right-width: 1;
  border-right-color: ${({ theme }) => theme.colors.gray_300};
  border-right-style: solid;

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0;
    border-right: none;
    border-bottom-width: 1;
    border-bottom-color: ${({ theme }) => theme.colors.gray_300};
    border-bottom-style: solid;
  }
`;

const Tab = styled.div<TabProps>`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.colors.white};
  z-index: 10;
  border-right-width: ${({ areaIndex }) => (areaIndex ? 4 : 0)};
  border-right-color: ${({ areaIndex, theme }) => (areaIndex ? theme.colors.primary_400 : theme.colors.white)};
  color: ${({ areaIndex, theme }) => (areaIndex ? theme.colors.primary_400 : theme.colors.gray_600)};
  font-weight: ${({ areaIndex }) => (areaIndex ? 'bold' : 'normal')};
  border-right-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.colors.gray_300};
  border-bottom-style: solid;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-right: 32px;
  padding-left: 16px;
  align-items: flex-start;
  width: 320px;
  text-align: end;
  font-size: 16px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 100%;
    text-align: start;
    padding: 16px;
  }
`;

const SubmenuVertical = ({ areas, areaIndex, onAreaClick }: SubmenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return !!areas?.length ? (
    <Wrapper>
      <Flex flexDirection="column" alignItems="flex-end" paddingTop={isMobile ? 0 : 60}>
        {isMobile && !isOpen ? (
          <Tab areaIndex={true} onClick={() => setIsOpen(true)}>
            <span>{areas[areaIndex]}</span>

            <Icon icon="chevronDown" />
          </Tab>
        ) : (
          [...areas].map((area, index) => (
            <Tab
              key={`area-tab-${area}-${index.toString()}`}
              areaIndex={areaIndex === index}
              onClick={() => {
                onAreaClick(index);
                if (isMobile) setIsOpen(false);
              }}
            >
              <span className="mdc-tab__text-label">{area}</span>
            </Tab>
          ))
        )}
      </Flex>
    </Wrapper>
  ) : (
    <></>
  );
};

export default SubmenuVertical;
